import React, { useState } from 'react';
import { Loader2, Mail, MailCheck, Unplug, Users } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { errMsg } from '@/services/staffAttendanceApi';
import { ptApi } from '@/services/ptFilesApi';

/** Which Gmail the PT emails go from, Connect / Disconnect, and the CC list. */
export const PtMailBar = ({ gmail, onChanged, onCc }) => {
  const [busy, setBusy] = useState(false);
  const connect = async () => {
    setBusy(true);
    try { window.location.assign(await ptApi.gmailConnect()); } catch (e) { toast.error(errMsg(e, 'Could not start the Gmail sign-in')); setBusy(false); }
  };
  const disconnect = async () => {
    if (!window.confirm(`Stop sending PT emails from ${gmail.email}?`)) return;
    setBusy(true);
    try { await ptApi.gmailDisconnect(); toast.success('Gmail disconnected'); onChanged(); } catch (e) { toast.error(errMsg(e, 'Could not disconnect')); } finally { setBusy(false); }
  };
  if (!gmail) return null;
  const cc = gmail.settings?.cc || [];
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-[#EFE8D8] bg-white px-4 py-2.5 text-sm" data-testid="pt-mail-bar">
      {gmail.connected ? (
        <span className="inline-flex items-center gap-1.5 text-emerald-700" data-testid="pt-gmail-connected"><MailCheck className="w-4 h-4" />Emails go from <b>{gmail.email}</b></span>
      ) : (
        <span className="inline-flex items-center gap-1.5 text-gray-600" data-testid="pt-gmail-not-connected"><Mail className="w-4 h-4" />Gmail isn't connected — connect it once to email PT files</span>
      )}
      <span className="text-gray-500" data-testid="pt-cc-summary">CC: {cc.length ? cc.join(', ') : 'none'}</span>
      <div className="ml-auto flex gap-2">
        <Button size="sm" variant="outline" onClick={onCc} data-testid="pt-cc-btn"><Users className="w-4 h-4 mr-1" />CC addresses</Button>
        {gmail.connected
          ? <Button size="sm" variant="ghost" disabled={busy} onClick={disconnect} className="text-rose-600" data-testid="pt-gmail-disconnect"><Unplug className="w-4 h-4 mr-1" />Disconnect</Button>
          : <Button size="sm" disabled={busy} onClick={connect} className="bg-[#2D5F4F] hover:bg-[#244c3f]" data-testid="pt-gmail-connect">
            {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Mail className="w-4 h-4 mr-1" />}Connect Gmail</Button>}
      </div>
    </div>
  );
};
